import { useEffect } from 'react'
import { useNavigate } from '@tanstack/react-router'
import { useAuth } from '@/features/auth'

export default function DashboardRouter() {
  const { profile, loading } = useAuth()
  const navigate = useNavigate()

  useEffect(() => {
    if (loading) return
    if (!profile) return

    if (profile.role === 'instructor') {
      navigate({ to: '/dashboard/instructor' })
    } else if (profile.role === 'admin') {
      navigate({ to: '/dashboard/admin' })
    } else {
      navigate({ to: '/dashboard/student' })
    }
  }, [profile, loading, navigate])

  return (
    <div className="min-h-screen flex items-center justify-center">
      <p className="text-gray-500 dark:text-gray-400 text-sm">Loading your dashboard...</p>
    </div>
  )
}